import { Component, TemplateRef, ViewChild, input } from '@angular/core';

@Component({
  selector: 'fin-accordion-item',
  template: `<ng-template #contentTpl><ng-content /></ng-template>`,
})
export class AccordionItemComponent {
  label = input.required<string>();
  key = input.required<string>();

  @ViewChild('contentTpl', { static: true })
  content: TemplateRef<unknown>;
}
